import * as types from '../../actions/ActionTypes';

export const initialState = {
  comments: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FILL_COMMENTS:
      return {
        ...state,
        comments: action.comments,
      };
    case types.ADD_COMMENT:
      return {
        ...state,
        comments: [...state.comments, action.comment],
      };
    case types.REMOVE_COMMENT:
      return {
        ...state,
        comments: state.comments.filter((comment) => comment.id !== action.commentId),
      };
    default:
      return state;
  }
}
